"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9712],{

/***/ 77462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59106);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78049);
/* harmony import */ var react_native_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24734);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_2__);






var SvgSearch = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size) {
        outProps.width = size;
        outProps.height = size;
    }
    if (color) {
        var colorToken = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Svg */ .ny, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Path */ .y$, {
            fill: "#786E64",
            d: "M9.5 16q-2.725 0-4.612-1.888T3 9.5t1.888-4.612Q6.778 3 9.5 3t4.613 1.888T16 9.5a6.1 6.1 0 0 1-1.3 3.8l5.6 5.6a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-5.6-5.6q-.75.6-1.725.95T9.5 16m0-2q1.875 0 3.188-1.312T14 9.5q0-1.876-1.312-3.187Q11.377 5.002 9.5 5T6.313 6.313 5 9.5t1.313 3.188T9.5 14"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgSearch);


/***/ }),

/***/ 55285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TextButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59106);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64069);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _generated_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11141);
/* harmony import */ var _generated_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7238);
/* harmony import */ var _helpers_tokens__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74609);
/* harmony import */ var _shared_anchorOrButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36838);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(84402);











var textButtonTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__/* .tokens.textButton */ .T.textButton, buttonTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__/* .tokens.button */ .T.button;
var sharedFrameConfig = {
    name: "TextButton",
    display: "flex",
    flexDirection: "row",
    gap: textButtonTokens.padding.labelIconGap.default,
    userSelect: "none",
    cursor: "pointer",
    // Browser resets
    padding: 0,
    borderWidth: 0,
    backgroundColor: "$transparent",
    focusVisibleStyle: {
        outlineStyle: "solid",
        outlineWidth: textButtonTokens.borderWidth.state.default,
        outlineOffset: textButtonTokens.padding.state.focused.default,
        borderRadius: textButtonTokens.cornerRadius.state.focused
    },
    pressStyle: {
        scale: (0,_helpers_tokens__WEBPACK_IMPORTED_MODULE_2__/* .getStateTokenValue */ .GJ)(buttonTokens.state.pressedScale)
    },
    variants: {
        variant: function(variant) {
            return {
                focusVisibleStyle: {
                    outlineColor: variant === "secondaryInverse" ? textButtonTokens.color.border.state.inverse : textButtonTokens.color.border.state.default
                }
            };
        },
        disabled: {
            true: {
                pointerEvents: "none"
            }
        }
    }
};
var AnchorFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, sharedFrameConfig), {
    tag: "a",
    accessibilityRole: "link",
    textDecorationLine: "none",
    display: "flex",
    position: "relative"
}));
var ButtonFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.View, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, sharedFrameConfig), {
    tag: "button",
    accessibilityRole: "button"
}));
var AnchorOrButtonFrame = (0,_shared_anchorOrButton__WEBPACK_IMPORTED_MODULE_6__/* .createAnchorOrButtonFrame */ .r)({
    AnchorFrame: AnchorFrame,
    ButtonFrame: ButtonFrame
});
/**
 * The TextButton component is a pressable element that's styled to be
 * less-pronounced than the regular Button component. The component is similar
 * to the "nav" variant of the Link component in the old version of bricks. In
 * this version of bricks, TextButton and Link are separate components. Use Link
 * when the clickable text should be inline with other text (e.g., in the middle
 * of a paragraph), and use TextButton when the clickable text should be set off
 * on its own. With TextButton, you can also pass a `chevronIcon` prop to show a
 * chevron on either the left or the right side of the button text.
 *
 * Like Button, TextButton accepts an `href` prop that lets you use the
 * component for URL-based navigation. Refer to the Button component docs for
 * more information. Also refer to the Button docs for information on flexbox
 * and analytics props.
 */ var TextButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function TextButton(_param, ref) {
    var variant = _param.variant, disabled = _param.disabled, label = _param.label, onHoverIn = _param.onHoverIn, onHoverOut = _param.onHoverOut, chevronIcon = _param.chevronIcon, fontWeight = _param.fontWeight, _size = _param.size, size = _size === void 0 ? "medium" : _size, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "variant",
        "disabled",
        "label",
        "onHoverIn",
        "onHoverOut",
        "chevronIcon",
        "fontWeight",
        "size"
    ]);
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isHovering = _$ref[0], setIsHovering = _$ref[1];
    var hoverNone = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.useMedia)().hoverNone;
    var handleHoverIn = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        !hoverNone && setIsHovering(true);
        onHoverIn === null || onHoverIn === void 0 ? void 0 : onHoverIn(e);
    }, [
        hoverNone,
        onHoverIn
    ]);
    var handleHoverOut = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        !hoverNone && setIsHovering(false);
        onHoverOut === null || onHoverOut === void 0 ? void 0 : onHoverOut(e);
    }, [
        hoverNone,
        onHoverOut
    ]);
    var color = disabled ? textButtonTokens.color.content.state.inactive[variant] : isHovering ? textButtonTokens.color.content.state.hover[variant] : textButtonTokens.color.content[variant];
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(AnchorOrButtonFrame, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        variant: variant,
        disabled: disabled,
        "aria-disabled": disabled,
        focusable: !disabled,
        onHoverIn: handleHoverIn,
        onHoverOut: handleHoverOut,
        ref: ref
    }, rest), {
        children: [
            chevronIcon === "left" && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_generated_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                size: size === "large" ? 24 : 20,
                color: color
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_Text__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                tag: "span",
                typography: textButtonTokens.typography[size],
                textDecorationLine: variant === "primary" || chevronIcon ? "none" : "underline",
                color: color,
                fontWeight: fontWeight ? textButtonTokens.fontWeight[fontWeight] : undefined,
                children: label
            }),
            chevronIcon === "right" && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_generated_icons__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                size: size === "large" ? 24 : 20,
                color: color
            })
        ]
    }));
});


/***/ }),

/***/ 57854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ Dropdown; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@opendoor+tokens-studio@16.2.0/node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(64069);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+core@1.110.0_react@18.3.1/node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(64978);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-native-web@0.19.13_encoding@0.1.13_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-native-web/dist/exports/StyleSheet/index.js + 8 modules
var StyleSheet = __webpack_require__(11945);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-native-web@0.19.13_encoding@0.1.13_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-native-web/dist/exports/PixelRatio/index.js
var PixelRatio = __webpack_require__(55161);
// EXTERNAL MODULE: ../bricks-next/src/__generated__/icons/ChevronUp.tsx
var ChevronUp = __webpack_require__(34140);
// EXTERNAL MODULE: ../bricks-next/src/__generated__/icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(75683);
// EXTERNAL MODULE: ../bricks-next/src/helpers/fontTokens.ts
var fontTokens = __webpack_require__(63501);
// EXTERNAL MODULE: ../bricks-next/src/helpers/utils.ts
var utils = __webpack_require__(91158);
// EXTERNAL MODULE: ../bricks-next/src/components/shared/TrackableContainer.tsx
var TrackableContainer = __webpack_require__(90143);
// EXTERNAL MODULE: ../bricks-next/src/components/inputs/shared/hooks.ts
var hooks = __webpack_require__(39390);
// EXTERNAL MODULE: ../bricks-next/src/components/inputs/shared/InputError.tsx
var InputError = __webpack_require__(63060);
// EXTERNAL MODULE: ../bricks-next/src/components/inputs/shared/InputFrame.tsx
var InputFrame = __webpack_require__(16660);
// EXTERNAL MODULE: ../bricks-next/src/components/inputs/shared/InputLabel.tsx
var InputLabel = __webpack_require__(77651);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-native-web@0.19.13_encoding@0.1.13_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-native-web/dist/exports/View/index.js
var View = __webpack_require__(45959);
;// CONCATENATED MODULE: ../bricks-next/src/components/inputs/Dropdown/PickerSelect.tsx
/**
 * Adapted from react-native-picker-select and @react-native-picker/picker.
 * These libs weren't compatible with vite, so we had to create our own
 * implementation for web. We're still using the libs on native (see:
 * PickerSelect.native.tsx).
 */ 





var getSelectedItem = function(param) {
    var items = param.items, key = param.key, value = param.value;
    var idx = items.findIndex(function(item) {
        if (item.key && key) {
            return item.key === key;
        }
        return item.value === value;
    });
    if (idx === -1) {
        idx = 0;
    }
    return items[idx] || {};
};
/**
 * Renders <select> on web
 */ var PickerSelect = function(param) {
    var disabled = param.disabled, style = param.style, pickerProps = param.pickerProps, Icon = param.Icon, items = param.items, placeholder = param.placeholder, itemKey = param.itemKey, value = param.value, onValueChange = param.onValueChange;
    var allItems = [
        placeholder
    ].concat(items);
    var ref = (0,react.useState)(getSelectedItem({
        items: allItems,
        key: itemKey,
        value: value
    })), selectedItem = ref[0], setSelectedItem = ref[1];
    var handleValueChange = function(value) {
        var selectedItem = getSelectedItem({
            items: allItems,
            value: value
        });
        setSelectedItem(selectedItem);
        onValueChange(selectedItem.value);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(View/* default */.Z, {
        style: [
            {
                alignSelf: "stretch"
            },
            style === null || style === void 0 ? void 0 : style.viewContainer, 
        ],
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Picker, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                style: style === null || style === void 0 ? void 0 : style.inputWeb,
                enabled: !disabled,
                onValueChange: handleValueChange,
                selectedValue: selectedItem.value
            }, pickerProps), {
                children: allItems.map(function(item) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                        value: item.value,
                        label: item.label,
                        children: item.label
                    }, item.key);
                })
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconComponent, {
                Icon: Icon,
                style: style
            })
        ]
    });
};
var IconComponent = function(param) {
    var Icon = param.Icon, style = param.style;
    if (!Icon) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(View/* default */.Z, {
        style: [
            {
                position: "absolute",
                right: 0
            },
            style === null || style === void 0 ? void 0 : style.iconContainer, 
        ],
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {})
    });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var Select = /*#__PURE__*/ (0,react.forwardRef)(function Select(props, forwardedRef) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        ref: forwardedRef
    }));
});
var Picker = /*#__PURE__*/ (0,react.forwardRef)(function Picker(_param, forwardedRef) {
    var enabled = _param.enabled, onValueChange = _param.onValueChange, selectedValue = _param.selectedValue, children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "enabled",
        "onValueChange",
        "selectedValue",
        "children"
    ]);
    var handleChange = function(e) {
        var _target = e.target, selectedIndex = _target.selectedIndex, value = _target.value;
        if (onValueChange) {
            onValueChange(value, selectedIndex);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        disabled: enabled === false ? true : undefined,
        onChange: handleChange,
        ref: forwardedRef,
        value: selectedValue
    }, other), {
        children: children
    }));
});

;// CONCATENATED MODULE: ../bricks-next/src/components/inputs/Dropdown/Dropdown.tsx

















var textInputTokens = Components/* tokens.textInput */.T.textInput;
/**
 * The Dropdown component lets the user select a single option from a menu. It
 * renders the native `<select>` element on web and a React Native component that
 * emulates native pickers on Android and iOS. (Under the hood it uses the
 * [react-native-picker-select](https://github.com/lawnstarter/react-native-picker-select)
 * library.)
 *
 * The placeholder text defaults to "Select an item". Pass
 * `placeholderOption.label` to customize the placeholder text. If needed, you
 * can also customize the value of the placeholder by passing
 * `placeholderOption.value` (it defaults to an empty string).
 *
 * Pass `required` to make the dropdown a required field. When the dropdown is
 * required, it will show an error message if the user selects the placeholder
 * option or blurs the select element without choosing an option. The error
 * message defaults to "This field is required" but you can customize it by
 * passing `customErrorMessages.fieldRequired`.
 *
 * If you want an initial value to appear in the dropdown, you can pass it as a `prefilledValue` prop. This should be a value that does not change after the initial render.
 *
 * Pass `onValidationChange` to be notified when the dropdown's validation
 * state changes. This is useful for disabling submit buttons while the dropdown
 * is in an invalid state. (See also: the ValidatedTextInput docs)
 *
 * If you want to track impression events ("inputViewEvent"), pass
 * `analyticsName` and `trackImpression`.
 */ var Dropdown = function(_param) {
    var analyticsName = _param.analyticsName, trackImpression = _param.trackImpression, title = _param.title, supportText = _param.supportText, required = _param.required, externalErrorText = _param.errorText, externalInvalid = _param.invalid, disabled = _param.disabled, id = _param.id, name = _param.name, onFocus = _param.onFocus, externalOnBlur = _param.onBlur, onOpen = _param.onOpen, onClose = _param.onClose, onValueChange = _param.onValueChange, onOptionChange = _param.onOptionChange, options = _param.options, placeholderOption = _param.placeholderOption, prefilledValue = _param.prefilledValue, customErrorMessages = _param.customErrorMessages, onValidationChange = _param.onValidationChange, propsIn = (0,_object_without_properties/* default */.Z)(_param, [
        "analyticsName",
        "trackImpression",
        "title",
        "supportText",
        "required",
        "errorText",
        "invalid",
        "disabled",
        "id",
        "name",
        "onFocus",
        "onBlur",
        "onOpen",
        "onClose",
        "onValueChange",
        "onOptionChange",
        "options",
        "placeholderOption",
        "prefilledValue",
        "customErrorMessages",
        "onValidationChange"
    ]);
    var _ref = (0,cjs.useProps)(propsIn), _size = _ref.size, size = _size === void 0 ? "medium" : _size, props = (0,_object_without_properties/* default */.Z)(_ref, [
        "size"
    ]);
    var pickerId = (0,hooks/* useInputId */.U0)(id);
    var items = (0,react.useMemo)(function() {
        return options.map(function(param) {
            var label = param.label, value = param.value;
            return {
                label: label,
                value: value,
                key: value
            };
        });
    }, [
        options
    ]);
    var placeholder = (0,react.useMemo)(function() {
        var ref, ref1;
        return {
            label: (ref = placeholderOption === null || placeholderOption === void 0 ? void 0 : placeholderOption.label) !== null && ref !== void 0 ? ref : "Select an item",
            value: (ref1 = placeholderOption === null || placeholderOption === void 0 ? void 0 : placeholderOption.value) !== null && ref1 !== void 0 ? ref1 : "",
            key: "placeholder"
        };
    }, [
        placeholderOption === null || placeholderOption === void 0 ? void 0 : placeholderOption.label,
        placeholderOption === null || placeholderOption === void 0 ? void 0 : placeholderOption.value
    ]);
    var ref = (0,react.useState)(prefilledValue !== null && prefilledValue !== void 0 ? prefilledValue : placeholder.value), value = ref[0], setValue = ref[1];
    var ref1 = (0,react.useState)(), internalErrorText = ref1[0], setInternalErrorText = ref1[1];
    var ref2 = (0,react.useState)("unknown"), internalValidationState = ref2[0], setInternalValidationState = ref2[1];
    var validate = (0,react.useCallback)(function(value) {
        var errorText;
        var validationState = "valid";
        if (value === "" && required) {
            var ref;
            errorText = (ref = customErrorMessages === null || customErrorMessages === void 0 ? void 0 : customErrorMessages.fieldRequired) !== null && ref !== void 0 ? ref : "This field is required";
            validationState = "invalid";
        }
        setInternalErrorText(errorText);
        setInternalValidationState(validationState);
        return validationState;
    }, [
        required,
        customErrorMessages === null || customErrorMessages === void 0 ? void 0 : customErrorMessages.fieldRequired
    ]);
    var handleValueChange = (0,react.useCallback)(function(val) {
        var value = typeof val === "string" ? val : "";
        setValue(value);
        var selectedOption = options.find(function(opt) {
            return opt.value === value;
        });
        var option = selectedOption || placeholderOption || {
            label: placeholder.label,
            value: placeholder.value
        };
        if (onValueChange) {
            onValueChange(value);
        }
        if (onOptionChange) {
            onOptionChange(option);
        }
        var validationState = validate(value);
        if (onValidationChange) {
            onValidationChange(validationState);
        }
    }, [
        validate,
        onValueChange,
        onOptionChange,
        onValidationChange,
        options,
        placeholderOption,
        placeholder, 
    ]);
    var onBlur = (0,react.useCallback)(function(e) {
        validate(value);
        externalOnBlur && externalOnBlur(e);
    }, [
        value,
        validate,
        externalOnBlur
    ]);
    var errorText = externalErrorText !== null && externalErrorText !== void 0 ? externalErrorText : internalErrorText;
    var invalid = !!errorText || externalInvalid || internalValidationState === "invalid";
    var ref3 = (0,hooks/* useInputState */.U1)({
        errorText: errorText,
        invalid: invalid,
        disabled: disabled,
        onFocus: onFocus,
        onBlur: onBlur
    }), state = ref3.state, handleBlur = ref3.handleBlur, handleFocus = ref3.handleFocus, setFocused = ref3.setFocused;
    var handleOpen = (0,react.useCallback)(function() {
        setFocused(true);
        onOpen && onOpen();
    }, [
        setFocused,
        onOpen
    ]);
    var handleClose = (0,react.useCallback)(function() {
        setFocused(false);
        validate(value);
        onClose && onClose();
    }, [
        setFocused,
        validate,
        value,
        onClose
    ]);
    var ref4 = (0,react.useMemo)(function() {
        return getStyles({
            size: size,
            state: state
        });
    }, [
        size,
        state
    ]), frameHeight = ref4.frameHeight, inputStyles = ref4.inputStyles, viewContainerStyles = ref4.viewContainerStyles, placeholderStyles = ref4.placeholderStyles, iconContainerStyles = ref4.iconContainerStyles, iconStyles = ref4.iconStyles;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackableContainer/* TrackableContainer */.z, {
        analyticsName: analyticsName,
        trackImpression: trackImpression,
        eventName: "inputViewEvent",
        gap: textInputTokens.padding.gap.textAndField[size],
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputLabel/* InputLabel */.A, {
                size: size,
                title: title,
                supportText: supportText,
                id: pickerId,
                required: required,
                state: state
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputFrame/* InputFrame */.z, {
                size: size,
                state: state,
                height: frameHeight,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PickerSelect, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    items: items,
                    disabled: disabled,
                    placeholder: placeholder,
                    value: value,
                    onValueChange: handleValueChange,
                    pickerProps: (0,_object_spread/* default */.Z)({
                        id: pickerId,
                        onFocus: handleFocus,
                        onBlur: handleBlur
                    }, cjs.isWeb ? {
                        "aria-invalid": state === "error",
                        "aria-required": required,
                        name: name
                    } : {}),
                    onOpen: handleOpen,
                    onClose: handleClose,
                    useNativeAndroidPickerStyle: false,
                    fixAndroidTouchableBug: true,
                    style: {
                        viewContainer: viewContainerStyles,
                        inputWeb: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputStyles, value === placeholder.value ? placeholderStyles : {}), {
                            outlineStyle: "none",
                            cursor: state === "inactive" ? "default" : "pointer",
                            appearance: "none",
                            textOverflow: "ellipsis"
                        }),
                        inputIOS: inputStyles,
                        chevronUp: {
                            display: "none"
                        },
                        chevronDown: {
                            display: "none"
                        },
                        inputAndroid: inputStyles,
                        headlessAndroidContainer: StyleSheet/* default.absoluteFill */.Z.absoluteFill,
                        iconContainer: iconContainerStyles,
                        placeholder: placeholderStyles
                    },
                    touchableWrapperProps: cjs.isAndroid ? {
                        style: viewContainerStyles
                    } : {},
                    Icon: function() {
                        return(// This toggles the chevron icon on ios/android. On web, there doesn't
                        // seem to be a good way to know if the picker is open because it's
                        // possible to focus the picker without opening it and `select`
                        // doesn't have an event corresponding to open/close.
                        !cjs.isWeb && state === "focused" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChevronUp/* default */.Z, (0,_object_spread/* default */.Z)({}, iconStyles)) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChevronDown/* default */.Z, (0,_object_spread/* default */.Z)({}, iconStyles)));
                    }
                }))
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputError/* InputError */.p, {
                errorText: errorText
            })
        ]
    });
};
var getStyles = function(param) {
    var size = param.size, state = param.state;
    var typopgraphyToken = textInputTokens.typography.valueText[size];
    var colorToken = (0,utils/* isKeyOfObject */.E)(state, textInputTokens.color.content.valueText.state) ? textInputTokens.color.content.valueText.state[state] : textInputTokens.color.content.valueText.default;
    var paddingVerticalToken = textInputTokens.padding.topBottom[size];
    var paddingHorizontalToken = textInputTokens.padding.leftRight[size];
    var borderWidthToken = textInputTokens.borderWidth.default;
    var paddingVertical = (0,cjs.getTokenValue)(paddingVerticalToken, "space");
    var paddingHorizontal = (0,cjs.getTokenValue)(paddingHorizontalToken, "space");
    var borderWidth = (0,cjs.getTokenValue)(borderWidthToken, "space");
    var lineHeight = (0,fontTokens/* getTypographyValue */.Yp)(typopgraphyToken, "lineHeight");
    var fontScale = PixelRatio/* default.getFontScale */.Z.getFontScale();
    var frameHeight = lineHeight * fontScale + 2 * paddingVertical + 2 * borderWidth;
    var viewContainerStyles = {
        position: "absolute",
        top: -borderWidth,
        bottom: -borderWidth,
        left: -borderWidth,
        right: -borderWidth,
        zIndex: 1
    };
    var iconContainerStyles = {
        top: 0,
        bottom: 0,
        right: paddingHorizontal + borderWidth,
        justifyContent: "center",
        zIndex: -1
    };
    var fontWeight = (0,fontTokens/* getTypographyValue */.Yp)(typopgraphyToken, "weight");
    var iconSize = size === "small" || size === "xsmall" ? 20 : 24;
    var iconGap = (0,cjs.getTokenValue)(textInputTokens.padding.gap.textAndIcon.default, "space");
    var inputStyles = {
        fontFamily: (0,fontTokens/* getFontName */.Yw)(fontWeight),
        fontSize: (0,fontTokens/* getTypographyValue */.Yp)(typopgraphyToken, "size"),
        fontWeight: fontWeight,
        letterSpacing: (0,fontTokens/* getTypographyValue */.Yp)(typopgraphyToken, "letterSpacing"),
        color: (0,cjs.getTokenValue)(colorToken, "color"),
        borderWidth: borderWidth,
        borderColor: "transparent",
        backgroundColor: "transparent",
        height: frameHeight,
        paddingVertical: paddingVertical,
        paddingLeft: paddingHorizontal,
        paddingRight: paddingHorizontal + iconSize + iconGap
    };
    var placeholderStyles = {
        color: (0,cjs.getTokenValue)(textInputTokens.color.content.placeholderText.default, "color")
    };
    var iconStyles = {
        size: iconSize,
        color: colorToken
    };
    return {
        frameHeight: frameHeight,
        viewContainerStyles: viewContainerStyles,
        iconContainerStyles: iconContainerStyles,
        inputStyles: inputStyles,
        placeholderStyles: placeholderStyles,
        iconStyles: iconStyles
    };
};


/***/ }),

/***/ 67974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ AddressInput_AddressInput; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92336);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Box.tsx
var Box = __webpack_require__(22901);
// EXTERNAL MODULE: ../bricks-next/src/components/Button/Button.tsx
var Button = __webpack_require__(56865);
// EXTERNAL MODULE: ../bricks-next/src/components/Text/index.tsx
var Text = __webpack_require__(84402);
// EXTERNAL MODULE: ../bricks-next/src/__generated__/icons/Search.tsx
var Search = __webpack_require__(77462);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/debounce.js
var debounce = __webpack_require__(77837);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../observability/src/global.ts
var global = __webpack_require__(96602);
// EXTERNAL MODULE: ../../node_modules/.pnpm/js-cookie@2.1.4/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(37462);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ../cinderblocks/src/helpers/globals.ts
var globals = __webpack_require__(94777);
;// CONCATENATED MODULE: ../cinderblocks/src/helpers/api.ts
/* provided dependency */ var process = __webpack_require__(73656);







var DEPLOY_ENV = (0,globals/* getDeployEnv */.BS)();
var XSRF_COOKIE_KEY = DEPLOY_ENV !== "development" ? "XSRF-G-TOKEN" : "XSRF-TOKEN";
var DEFAULT_LOCALDEV_ATHENA_URL = "http://localhost:4000/api/graphql";
var getWindowEnv = function() {
    if (false) {}
    return window.ENV;
};
var getLocaldevAthenaUrl = function() {
    var windowEnv = getWindowEnv();
    return (windowEnv === null || windowEnv === void 0 ? void 0 : windowEnv.ODFE_ATHENA_URL) || (windowEnv === null || windowEnv === void 0 ? void 0 : windowEnv.REACT_APP_GRAPHQL_API_URL) || typeof process !== "undefined" && process.env.ODFE_ATHENA_URL || typeof process !== "undefined" && process.env.REACT_APP_GRAPHQL_API_URL || DEFAULT_LOCALDEV_ATHENA_URL;
};
// Hit staging Athena by default in development
//
// To hit local Athena invert the comment & uncommented `development` keys
var ATHENA_URLS = {
    production: "https://graphql.apps.opendoor.com/api/graphql",
    // development: 'http://localhost:4000/api/graphql',
    development: "https://graphql.simplersell.com/api/graphql",
    // development: 'http://athena-api-nginx-vpn-http.apps.internal.opendoor.com/api/graphql',
    localdev: getLocaldevAthenaUrl(),
    qa: "https://graphql.simplersell.com/api/graphql",
    staging: "https://graphql.simplersell.com/api/graphql",
    test: "https://graphql.simplersell.com/api/graphql"
};
var ATHENA_URL = ATHENA_URLS[DEPLOY_ENV];
/**
 * A wrapper around `fetch` with optional retries.
 * Retries up to `options.retries` times (defaults to `5` if not specified)
 * with a delay of `options.retryDelay` (defaults to `500ms` if not specified)
 */ var fetchWithRetry = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(url, options) {
        var retries, retryDelay, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    retries = options.retries || 0;
                    retryDelay = options.retryDelay || 500;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        6
                    ]);
                    return [
                        4,
                        fetch(url, options)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    err = _state.sent();
                    if (retries < 1) throw err;
                    // sleep the specified amount of time, then recursively retry
                    return [
                        4,
                        new Promise(function(r) {
                            return setTimeout(r, retryDelay);
                        })
                    ];
                case 4:
                    _state.sent();
                    return [
                        4,
                        fetchWithRetry(url, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                            retries: retries - 1
                        }))
                    ];
                case 5:
                    return [
                        2,
                        _state.sent()
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchWithRetry(url, options) {
        return _ref.apply(this, arguments);
    };
}();
var Sentry = global/* globalObservability.getSentryClient */.w.getSentryClient();
function handleResponse(res) {
    var ref;
    if (res.ok) {
        return res.json();
    }
    (ref = Sentry.withScope) === null || ref === void 0 ? void 0 : ref.call(Sentry, function(scope) {
        var ref;
        scope.setExtras({
            resonse: res
        });
        (ref = Sentry.captureMessage) === null || ref === void 0 ? void 0 : ref.call(Sentry, "Non-200 response received in api call");
    });
    return undefined;
}
// To do: strengthen jsonParam's type
// Do not pass skip doBFFPost as it will not actually skip making the request - instead handle it conditionally
function doBFFPost(apiUrl, jsonParams) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return fetchWithRetry(apiUrl, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        retries: 5,
        retryDelay: 500,
        credentials: "include",
        method: "POST",
        body: JSON.stringify(jsonParams)
    }, options), {
        headers: (0,_object_spread/* default */.Z)({
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRF-Token": js_cookie_default().get(XSRF_COOKIE_KEY) || ""
        }, options.headers)
    }));
}
function listUnits(addressUUID) {
    return doBFFPost(ATHENA_URL, {
        operationName: "ListUnits",
        query: "query ListUnits($addressUUID: String!, $limit: Float!) {\n        casa {\n          listUnits(input: { uuid: $addressUUID, limit: $limit }) {\n            addresses{\n              uuid\n              result\n            }\n          }\n        }\n      }",
        variables: {
            addressUUID: addressUUID,
            limit: 10
        }
    }, {
        headers: {
            "apollographql-client-name": "cinderblocks"
        }
    }).then(handleResponse).catch(function(e) {
        var ref;
        return (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
    });
}
function standardizeAddress(address) {
    return doBFFPost(ATHENA_URL, {
        operationName: "StandardizeAddress",
        query: "query StandardizeAddress($address: OdProtosCasaServices_CasaRequest_FindByFieldsInput!) {\n      casa {\n        findByFields(input: $address) {\n          address {\n            uuid\n            street\n            city\n            state\n            unitNumber\n            unitType\n            postalCode\n            latitude\n            longitude\n            result\n          }\n        }\n      }\n    }",
        variables: {
            address: {
                city: address.city,
                postalCode: address.postal_code,
                state: address.state,
                street: address.street1,
                unitNumber: address.unit
            }
        }
    }, {
        headers: {
            "apollographql-client-name": "cinderblocks"
        }
    }).then(handleResponse).catch(function(e) {
        var ref;
        return (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
    });
}
function createMortgageLead(input) {
    var mutation = "\n    mutation MortgageLead($input: OdProtosCustomerFinancingServiceServices_CustomerFinancingRequests_CreateMortgageLeadInput!) {\n      customerFinancingService {\n        createMortgageLead(input: $input) {\n          mortgageLead {\n            mortgageLeadId\n            customerUuid\n          }\n        }\n      }\n    }\n  ";
    return doBFFPost(ATHENA_URL, {
        operationName: "MortgageLead",
        query: mutation,
        variables: {
            input: {
                customerUuid: input.customerUuid,
                channel: "CUSTOMER_EXPERIENCE",
                addressToken: input === null || input === void 0 ? void 0 : input.addressToken,
                propertyType: input.propertyType,
                targetMoveDate: input.targetMoveDate,
                targetPrice: input.targetPrice,
                targetDownPayment: input.targetDownPayment,
                targetLocation: input.targetLocation,
                employmentStatus: input.employmentStatus,
                householdIncomeMin: input.householdIncomeMin,
                householdIncomeMax: input.householdIncomeMax,
                firstName: input.firstName,
                lastName: input.lastName,
                phone: input.phone,
                email: input.email,
                currentAddress: input.currentAddress
            }
        }
    }, {
        headers: {
            "apollographql-client-name": "cinderblocks"
        }
    }).then(function() {
        var _ref = _async_to_generator(function(response) {
            var errorText, result;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!response.ok) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            response.text()
                        ];
                    case 1:
                        errorText = _state.sent();
                        throw new Error("GraphQL mutation failed: ".concat(errorText));
                    case 2:
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        result = _state.sent();
                        if (result.errors) {
                            throw new Error("GraphQL errors: ".concat(JSON.stringify(result.errors)));
                        }
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function(response) {
            return _ref.apply(this, arguments);
        };
    }()).catch(function(e) {
        var ref;
        (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
        throw e;
    });
}

;// CONCATENATED MODULE: ../cinderblocks/src/helpers/addressValidation.ts




var UNIVERSAL_NIL_ADDRESS = "6aae647b-d603-5533-8464-c42c658b101a";

var ADDRESS_INVALID_RESULT = [
    "ADDRESS_NIL",
    "ADDRESS_UNKNOWN",
    "ADDRESS_MISSING_PREMISE",
    "ADDRESS_INVALID_PREMISE",
    "ADDRESS_NOT_SUPPORTED",
    "ADDRESS_NOT_REAL",
    "ADDRESS_INVALID",
    "ADDRESS_INVALID_STREET",
    "ADDRESS_INVALID_SUB_PREMISE",
    "ADDRESS_MISSING_BOX_NUMBER",
    "ADDRESS_INVALID_BOX_NUMBER",
    "ADDRESS_EXTRANEOUS_INPUT", 
];
var doesAddressHaveMultipleUnits = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(addressUuid) {
        var ref, ref1, ref2, response, addresses;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        listUnits(addressUuid)
                    ];
                case 1:
                    response = _state.sent();
                    addresses = (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.casa) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.listUnits) === null || ref2 === void 0 ? void 0 : ref2.addresses) || [];
                    return [
                        2,
                        addresses.some(function(address) {
                            var ref;
                            return address.uuid !== addressUuid && !((ref = address.result) === null || ref === void 0 ? void 0 : ref.some(function(casaResult) {
                                return ADDRESS_INVALID_RESULT.includes(casaResult);
                            }));
                        })
                    ];
            }
        });
    });
    return function doesAddressHaveMultipleUnits(addressUuid) {
        return _ref.apply(this, arguments);
    };
}();
var addressValidation_validateAddress = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(address) {
        var ref, moreResult, casaAddress, ref1, ref2, ref3, ref4, ref5, standardizeAddressResponse, addressResult, _tmp, combinedResults, needsManualEntry, needsUnitSelection;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    moreResult = [];
                    casaAddress = address;
                    if (!(address.source === "google")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        standardizeAddress(address)
                    ];
                case 1:
                    standardizeAddressResponse = _state.sent();
                    if (!standardizeAddressResponse || !standardizeAddressResponse.data || standardizeAddressResponse.errors || ((ref2 = (ref1 = standardizeAddressResponse.data) === null || ref1 === void 0 ? void 0 : ref1.casa.findByFields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.address) === null || ref3 === void 0 ? void 0 : ref3.uuid) === UNIVERSAL_NIL_ADDRESS) {
                        moreResult = [
                            "ADDRESS_UNKNOWN"
                        ];
                        return [
                            2,
                            {
                                address: address,
                                results: moreResult,
                                needsManualEntry: true,
                                needsUnitSelection: false
                            }
                        ];
                    }
                    addressResult = (ref5 = (ref4 = standardizeAddressResponse.data) === null || ref4 === void 0 ? void 0 : ref4.casa.findByFields) === null || ref5 === void 0 ? void 0 : ref5.address;
                    casaAddress = {
                        id: addressResult.uuid,
                        street1: addressResult.street,
                        city: addressResult.city,
                        state: addressResult.state,
                        postal_code: addressResult.postalCode,
                        unit: addressResult.unitNumber,
                        result: addressResult.result,
                        latitude: address.latitude,
                        longitude: address.longitude,
                        source: "casa"
                    };
                    _state.label = 2;
                case 2:
                    if (!(!(casaAddress === null || casaAddress === void 0 ? void 0 : (ref = casaAddress.result) === null || ref === void 0 ? void 0 : ref.includes("ADDRESS_MISSING_SUB_PREMISE")) && (casaAddress === null || casaAddress === void 0 ? void 0 : casaAddress.unit) === "")) return [
                        3,
                        5
                    ];
                    _tmp = casaAddress.id;
                    if (!_tmp) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        doesAddressHaveMultipleUnits(casaAddress.id)
                    ];
                case 3:
                    _tmp = _state.sent();
                    _state.label = 4;
                case 4:
                    if (_tmp) {
                        moreResult = [
                            "ADDRESS_MISSING_SUB_PREMISE"
                        ];
                    }
                    _state.label = 5;
                case 5:
                    combinedResults = (0,_to_consumable_array/* default */.Z)((casaAddress === null || casaAddress === void 0 ? void 0 : casaAddress.result) || []).concat((0,_to_consumable_array/* default */.Z)(moreResult));
                    needsManualEntry = ADDRESS_INVALID_RESULT.some(function(error) {
                        return combinedResults.includes(error);
                    });
                    needsUnitSelection = combinedResults.includes("ADDRESS_MISSING_SUB_PREMISE");
                    return [
                        2,
                        {
                            address: casaAddress,
                            results: combinedResults,
                            needsManualEntry: needsManualEntry,
                            needsUnitSelection: needsUnitSelection
                        }
                    ];
            }
        });
    });
    return function validateAddress(address) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ../cinderblocks/src/helpers/googleMaps.ts
var googleMaps = __webpack_require__(74865);
// EXTERNAL MODULE: ../cinderblocks/src/core/AutocompleteInput/index.ts + 1 modules
var AutocompleteInput = __webpack_require__(87300);
;// CONCATENATED MODULE: ../cinderblocks/src/core/AddressInput/AddressInput.tsx












var DEBOUNCE_INVOKE_WAIT_MS = 100;
/**
 * @param actionButton overrides `icon` in the suffix position when provided
 */ var AddressInput = function(param) {
    var id = param.id, placeholder = param.placeholder, disabled = param.disabled, hideLabel = param.hideLabel, label = param.label, value = param.value, onChange = param.onChange, defaultValue = param.defaultValue, _fetchOnExternalValue = param.fetchOnExternalValue, fetchOnExternalValue = _fetchOnExternalValue === void 0 ? false : _fetchOnExternalValue, onAddressSelect = param.onAddressSelect, onAddressValidated = param.onAddressValidated, _validateAddress = param.validateAddress, validateAddress = _validateAddress === void 0 ? false : _validateAddress, onError = param.onError, onPredictionsChange = param.onPredictionsChange, onSearchTermChange = param.onSearchTermChange, onFocus = param.onFocus, onBlur = param.onBlur, customAction = param.customAction, listBoxId = param.listBoxId, listBoxAriaLabel = param.listBoxAriaLabel, icon = param.icon, actionButton = param.actionButton, size = param.size, supportText = param.supportText, errorText = param.errorText, invalid = param.invalid, required = param.required;
    var ref = (0,react.useState)([]), predictions = ref[0], setPredictions = ref[1];
    var ref1 = (0,react.useState)(null), usedPrediction = ref1[0], setUsedPrediction = ref1[1];
    var ref2 = (0,react.useState)(defaultValue !== null && defaultValue !== void 0 ? defaultValue : ""), internalSearchTerm = ref2[0], setInternalSearchTerm = ref2[1];
    var ref3 = (0,react.useState)(false), isLoading = ref3[0], setIsLoading = ref3[1];
    var ref4 = (0,react.useState)(function() {
        return (0,googleMaps/* generateGoogleMapsSessionToken */.h_)();
    }), sessionToken = ref4[0];
    var inputRef = (0,react.useRef)(null);
    var didMountRef = (0,react.useRef)(false);
    // Determine if component is controlled (value prop is provided)
    var isControlled = value !== undefined;
    var searchTerm = isControlled ? value : internalSearchTerm;
    var updateSearchTerm = function(newValue) {
        if (!isControlled) {
            setInternalSearchTerm(newValue);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
    };
    (0,react.useEffect)(function() {
        onPredictionsChange === null || onPredictionsChange === void 0 ? void 0 : onPredictionsChange(predictions);
    }, [
        predictions,
        onPredictionsChange
    ]);
    // For uncontrolled mode, notify on initial mount and when defaultValue changes
    // For controlled mode, the parent already knows the value
    (0,react.useEffect)(function() {
        if (!isControlled) {
            onSearchTermChange === null || onSearchTermChange === void 0 ? void 0 : onSearchTermChange(searchTerm);
        }
    }, [
        isControlled,
        searchTerm,
        onSearchTermChange
    ]);
    var clearPredictions = function() {
        setUsedPrediction(null);
        setPredictions([]);
    };
    var fetchAutocompleteOptions = (0,react.useMemo)(function() {
        return debounce_default()(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(input) {
                var response, data, filtered, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!input) {
                                clearPredictions();
                                return [
                                    2
                                ];
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                fetch((0,googleMaps/* buildAutocompleteUrl */.Iz)(input, sessionToken))
                            ];
                        case 2:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 3:
                            data = _state.sent();
                            // Clean descriptions by removing ', USA' and add required AutocompleteItem properties
                            data.predictions.forEach(function(result) {
                                result.description = result.description.replace(", USA", "");
                                result.id = result.place_id || result.addressToken || result.description;
                                result.ariaLabel = result.description;
                            });
                            filtered = data.predictions.filter(function(result) {
                                result.source = data.source;
                                if (data.source === "google") {
                                    var _terms;
                                    var terms = (_terms = result.terms) !== null && _terms !== void 0 ? _terms : [];
                                    var _types;
                                    var allowedTypes = ((_types = result.types) !== null && _types !== void 0 ? _types : []).filter(function(type) {
                                        return googleMaps/* ALLOWED_TYPES.includes */.MF.includes(type);
                                    });
                                    return terms.length >= 5 && allowedTypes.length > 0 || terms.length === 4 && terms[0].value.match(/^\d+\S*\s\S+\s/) !== null;
                                }
                                return true;
                            });
                            setPredictions(filtered);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            error = _state.sent();
                            clearPredictions();
                            onError === null || onError === void 0 ? void 0 : onError(error);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(input) {
                return _ref.apply(this, arguments);
            };
        }(), DEBOUNCE_INVOKE_WAIT_MS);
    }, [
        sessionToken,
        onError
    ]);
    // Handle external value changes when fetchOnExternalValue is enabled
    (0,react.useEffect)(function() {
        if (!fetchOnExternalValue) return;
        // Skip initial mount - only react to subsequent changes
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        // Sync predictions based on external value change
        if (searchTerm === "") {
            clearPredictions();
        } else {
            fetchAutocompleteOptions(searchTerm);
        }
    // clearPredictions is stable (no external dependencies), safe to omit
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchOnExternalValue,
        searchTerm,
        fetchAutocompleteOptions
    ]);
    var handleInputChange = function(e) {
        var newValue = e.target.value;
        updateSearchTerm(newValue);
        fetchAutocompleteOptions(newValue);
        if (newValue === "") {
            clearPredictions();
        }
    };
    var handlePredictionSelect = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(prediction) {
            var // Blur input to dismiss keyboard before async operations that may open modals
            ref, url, response, address, validationResult, validationError, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.blur();
                        setUsedPrediction(prediction);
                        updateSearchTerm(prediction.description);
                        setPredictions([]);
                        setIsLoading(true);
                        url = prediction.source === "google" ? (0,googleMaps/* buildPlacesUrl */.dl)({
                            source: "google",
                            placeId: prediction.place_id,
                            sessionToken: sessionToken
                        }) : (0,googleMaps/* buildPlacesUrl */.dl)({
                            source: "casa",
                            addressToken: prediction.addressToken,
                            sessionToken: sessionToken
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            10
                        ]);
                        return [
                            4,
                            fetch(url)
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        address = _state.sent();
                        if (!(validateAddress && onAddressValidated)) return [
                            3,
                            7
                        ];
                        _state.label = 4;
                    case 4:
                        _state.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4,
                            addressValidation_validateAddress(address)
                        ];
                    case 5:
                        validationResult = _state.sent();
                        onAddressValidated(validationResult);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        validationError = _state.sent();
                        onError === null || onError === void 0 ? void 0 : onError(validationError);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        onAddressSelect(address);
                        return [
                            3,
                            10
                        ];
                    case 8:
                        error = _state.sent();
                        onError === null || onError === void 0 ? void 0 : onError(error);
                        return [
                            3,
                            10
                        ];
                    case 9:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 10:
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePredictionSelect(prediction) {
            return _ref.apply(this, arguments);
        };
    }();
    var renderItem = function(prediction) {
        // Map size to typography for consistent styling
        var typographyMap = {
            xsmall: "$bodyMedium",
            small: "$bodyMedium",
            medium: "$bodyLarge",
            large: "$bodyXlarge"
        };
        var typography = size ? typographyMap[size] : "$bodyXlarge";
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
            typography: typography,
            tag: "span",
            textAlign: "left",
            $smallerThanMD: {
                typography: "$bodyMedium"
            },
            px: 10,
            py: 2,
            children: prediction.description
        });
    };
    var displayIcon = icon !== null && icon !== void 0 ? icon : isLoading ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        position: "relative",
        px: "$4",
        display: "block",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* ButtonLoadingAnimation */.V, {
            variant: "secondary",
            size: "xsmall"
        })
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Search/* default */.Z, {});
    var useSuffix = displayIcon;
    if (actionButton) {
        var onPress = function() {
            if (predictions.length && predictions[0]) {
                handlePredictionSelect(predictions[0]);
            } else if (usedPrediction && searchTerm === usedPrediction.description) {
                handlePredictionSelect(usedPrediction);
            }
        };
        var renderedButton = actionButton(onPress, isLoading);
        useSuffix = renderedButton;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AutocompleteInput/* default */.Z, {
        id: id,
        label: label,
        hideLabel: hideLabel,
        placeholder: placeholder,
        disabled: disabled,
        items: predictions,
        searchTerm: searchTerm,
        onSearchChange: handleInputChange,
        onItemSelect: handlePredictionSelect,
        renderItem: renderItem,
        suffix: useSuffix,
        customAction: customAction,
        listBoxId: listBoxId,
        onEscape: function() {
            return clearPredictions();
        },
        onFocus: onFocus,
        onBlur: onBlur,
        listBoxAriaLabel: listBoxAriaLabel,
        size: size,
        supportText: supportText,
        errorText: errorText,
        invalid: invalid,
        required: required,
        inputRef: inputRef
    });
};
/* harmony default export */ var AddressInput_AddressInput = (AddressInput);

;// CONCATENATED MODULE: ../cinderblocks/src/core/AddressInput/index.ts



/***/ }),

/***/ 87300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ AutocompleteInput_AutocompleteInput; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Box.tsx
var Box = __webpack_require__(22901);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/PressableBox.tsx
var PressableBox = __webpack_require__(54999);
// EXTERNAL MODULE: ../bricks-next/src/components/inputs/TextInput.tsx
var TextInput = __webpack_require__(78514);
;// CONCATENATED MODULE: ../cinderblocks/src/core/AutocompleteInput/AutocompleteInput.tsx






// Simple wrapper component similar to PickerSelect's approach
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var ListBoxElement = /*#__PURE__*/ react.forwardRef(function ListBoxElement(props, forwardedRef) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        ref: forwardedRef
    }));
});
var BricksNextListBox = function(param) {
    var children = param.children, listBoxId = param.listBoxId, _ariaLabel = param.ariaLabel, ariaLabel = _ariaLabel === void 0 ? "suggestions" : _ariaLabel, _size = param.size, size = _size === void 0 ? "medium" : _size;
    // Map size to border radius tokens that match TextInput
    var borderRadiusMap = {
        small: "$7x",
        medium: "$9x",
        large: "$12x"
    };
    var borderRadius = borderRadiusMap[size] || "$9x";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        borderBottomLeftRadius: borderRadius,
        borderBottomRightRadius: borderRadius,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        maxHeight: 450,
        position: "absolute",
        top: "100%",
        left: 0,
        right: 0,
        marginTop: -1.5,
        borderLeftWidth: 1.5,
        borderRightWidth: 1.5,
        borderBottomWidth: 1.5,
        borderTopWidth: 0,
        borderStyle: "solid",
        borderColor: "$borderAccentBrand",
        backgroundColor: "$backgroundPrimary",
        overflow: "hidden",
        zIndex: 1000,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListBoxElement, {
            role: "listbox",
            "aria-label": ariaLabel,
            id: listBoxId,
            style: {
                padding: 0,
                margin: 0,
                listStyleType: "none"
            },
            children: children
        })
    });
};
var AutocompleteInput = function(param) {
    var id = param.id, label = param.label, hideLabel = param.hideLabel, placeholder = param.placeholder, disabled = param.disabled, items = param.items, searchTerm = param.searchTerm, onSearchChange = param.onSearchChange, onItemSelect = param.onItemSelect, renderItem = param.renderItem, suffix = param.suffix, customAction = param.customAction, _listBoxId = param.listBoxId, listBoxId = _listBoxId === void 0 ? "autocomplete-listbox" : _listBoxId, listBoxAriaLabel = param.listBoxAriaLabel, onEscape = param.onEscape, onFocus = param.onFocus, onBlur = param.onBlur, _size = param.size, size = _size === void 0 ? "medium" : _size, supportText = param.supportText, errorText = param.errorText, invalid = param.invalid, required = param.required, externalInputRef = param.inputRef;
    var ref = (0,react.useState)(undefined), selectedIndex = ref[0], setSelectedIndex = ref[1];
    var ref1 = (0,react.useState)(false), isFocused = ref1[0], setIsFocused = ref1[1];
    var useBricksNext = true;
    var internalInputRef = (0,react.useRef)(null);
    var inputRef = externalInputRef || internalInputRef;
    // Reset selection when items change to prevent stale index
    (0,react.useEffect)(function() {
        if (selectedIndex !== undefined && selectedIndex >= items.length) {
            setSelectedIndex(undefined);
        }
    }, [
        items,
        selectedIndex
    ]);
    var handleItemSelect = (0,react.useCallback)(function(item) {
        return function() {
            var ref;
            onItemSelect(item);
            (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.blur();
        };
    }, [
        onItemSelect,
        inputRef
    ]);
    var onKeyDown = function(e) {
        if (e.key === "ArrowDown") {
            e.preventDefault();
            if (items.length > 0) {
                var newSelectedIndex = selectedIndex === undefined || selectedIndex === items.length - 1 ? 0 : selectedIndex + 1;
                setSelectedIndex(newSelectedIndex);
            }
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            if (items.length > 0) {
                var newSelectedIndex1 = selectedIndex === undefined || selectedIndex === 0 ? items.length - 1 : selectedIndex - 1;
                setSelectedIndex(newSelectedIndex1);
            }
        } else if (e.key === "Enter") {
            e.preventDefault();
            if (selectedIndex !== undefined && items[selectedIndex]) {
                var ref;
                onItemSelect(items[selectedIndex]);
                (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.blur();
            }
        } else if (e.key === "Escape") {
            setSelectedIndex(undefined);
            onEscape === null || onEscape === void 0 ? void 0 : onEscape();
        } else {
            setSelectedIndex(undefined);
        }
    };
    var handleContainerBlur = (0,react.useCallback)(function(e) {
        if (!e.currentTarget.contains(e.relatedTarget)) {
            setIsFocused(false);
            onBlur === null || onBlur === void 0 ? void 0 : onBlur();
        }
    }, [
        onBlur
    ]);
    var handleContainerFocus = (0,react.useCallback)(function() {
        setIsFocused(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
    }, [
        onFocus
    ]);
    var handleMouseDown = (0,react.useCallback)(function(e) {
        e.preventDefault();
    }, []);
    var showDropdown = searchTerm !== "" && isFocused;
    if (useBricksNext) {
        var textInputProps = {
            id: id,
            placeholder: placeholder,
            disabled: disabled,
            value: searchTerm,
            onChangeText: function(text) {
                var syntheticEvent = {
                    target: {
                        value: text
                    }
                };
                onSearchChange(syntheticEvent);
            },
            onKeyPress: onKeyDown,
            size: size,
            supportText: supportText,
            errorText: errorText,
            invalid: invalid,
            required: required,
            autoComplete: "off",
            role: "combobox",
            "aria-autocomplete": "list",
            "aria-expanded": showDropdown ? "true" : "false",
            "aria-controls": listBoxId
        };
        if (!hideLabel && label) {
            textInputProps.title = label;
        } else if (label) {
            textInputProps.ariaLabel = label;
        } else {
            textInputProps.ariaLabel = "Search input";
        }
        // Modify border styling when dropdown is showing AND there are items or customAction to display
        if (showDropdown && (items.length > 0 || customAction)) {
            textInputProps.frameProps = {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomWidth: 0
            };
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            onFocus: handleContainerFocus,
            onBlur: handleContainerBlur,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                position: "relative",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextInput/* TextInput */.o, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, textInputProps), {
                        ref: inputRef,
                        children: suffix
                    })),
                    showDropdown && (items.length > 0 || customAction) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BricksNextListBox, {
                        listBoxId: listBoxId,
                        ariaLabel: listBoxAriaLabel,
                        size: size,
                        children: [
                            items.map(function(item, index) {
                                var isSelected = selectedIndex === index;
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                    tag: "li",
                                    id: "autocomplete-options",
                                    role: "option",
                                    "aria-selected": isSelected || undefined,
                                    overflow: "hidden",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                                        zIndex: 2,
                                        justifyContent: "flex-start",
                                        onMouseDown: handleMouseDown,
                                        analyticsName: "",
                                        "aria-label": item.ariaLabel,
                                        animation: "accelerateDecelerateFastest",
                                        height: "100%",
                                        width: "100%",
                                        backgroundColor: isSelected ? "$backgroundStateHoverPrimary" : "$backgroundPrimary",
                                        hoverStyle: {
                                            backgroundColor: "$backgroundStateHoverPrimary"
                                        },
                                        onPress: handleItemSelect(item),
                                        pressStyle: {
                                            scale: 0.98
                                        },
                                        padding: 10,
                                        children: renderItem(item, isSelected)
                                    })
                                }, item.id);
                            }),
                            customAction
                        ]
                    })
                ]
            })
        });
    }
    return null;
};
/* harmony default export */ var AutocompleteInput_AutocompleteInput = (AutocompleteInput);

;// CONCATENATED MODULE: ../cinderblocks/src/core/AutocompleteInput/index.ts



/***/ }),

/***/ 94777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BS": function() { return /* binding */ getDeployEnv; },
/* harmony export */   "aD": function() { return /* binding */ isDevelopmentEnv; },
/* harmony export */   "n5": function() { return /* binding */ isProductionEnv; }
/* harmony export */ });
/* unused harmony exports GOOGLE_CLIENT_ID, GOOGLE_MAPS_KEY, SUPPORTED_LOCALES */
/* harmony import */ var _opendoor_shared_fe_commonGlobals__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7783);
/* harmony import */ var _opendoor_shared_fe_railsEnv__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7419);
/* provided dependency */ var process = __webpack_require__(73656);


var railsEnv = (0,_opendoor_shared_fe_railsEnv__WEBPACK_IMPORTED_MODULE_1__/* .getRailsEnv */ .YE)();
var secrets = _opendoor_shared_fe_commonGlobals__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[railsEnv];
var GOOGLE_CLIENT_ID = secrets.googleClientID;
var GOOGLE_MAPS_KEY = secrets.googleMaps;
var SUPPORTED_LOCALES = (/* unused pure expression or super */ null && ([
    "en-US",
    "es"
]));
/**
 * Gets the current environment in a framework-agnostic way.
 * Works with Next.js (Cosmos), Remix (Cake), and browser contexts.
 *
 * Priority order:
 * 1. window.ENV?.DEPLOY_ENV (Remix client-side)
 * 2. process.env.NEXT_PUBLIC_DEPLOY_ENV (Next.js client & server)
 * 3. process.env.DEPLOY_ENV (Remix server-side)
 * 4. getRailsEnv() (Fallback to hostname detection)
 */ /* eslint-disable @opendoor/no-direct-env-check -- implementing the helper function */ var getDeployEnv = function() {
    var ref, ref1, ref2;
    // Check window.ENV first (Remix pattern)
    if ( true && ((ref = window.ENV) === null || ref === void 0 ? void 0 : ref.DEPLOY_ENV)) {
        return window.ENV.DEPLOY_ENV;
    }
    // Check Next.js public env var
    if (typeof process !== "undefined" && ((ref1 = process.env) === null || ref1 === void 0 ? void 0 : "production")) {
        return "production";
    }
    // Check Remix server env var
    if (typeof process !== "undefined" && ((ref2 = process.env) === null || ref2 === void 0 ? void 0 : ref2.DEPLOY_ENV)) {
        return process.env.DEPLOY_ENV;
    }
    // Falls back to Rails env method in shared-fe
    return (0,_opendoor_shared_fe_railsEnv__WEBPACK_IMPORTED_MODULE_1__/* .getRailsEnv */ .YE)();
};
/* eslint-enable @opendoor/no-direct-env-check */ /**
 * Checks if the current deploy environment is production.
 */ var isProductionEnv = function() {
    return getDeployEnv() === "production";
};
/**
 * Checks if the current deploy environment is development.
 */ var isDevelopmentEnv = function() {
    return getDeployEnv() === "development";
};


/***/ }),

/***/ 74865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iz": function() { return /* binding */ buildAutocompleteUrl; },
/* harmony export */   "MF": function() { return /* binding */ ALLOWED_TYPES; },
/* harmony export */   "dl": function() { return /* binding */ buildPlacesUrl; },
/* harmony export */   "h_": function() { return /* binding */ generateGoogleMapsSessionToken; },
/* harmony export */   "wC": function() { return /* binding */ buildCityAutocompleteUrl; }
/* harmony export */ });
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94777);

var getAddressInputUrl = function() {
    if ((0,_globals__WEBPACK_IMPORTED_MODULE_0__/* .isProductionEnv */ .n5)() || (0,_globals__WEBPACK_IMPORTED_MODULE_0__/* .getDeployEnv */ .BS)() === "localdev") {
        return "/_address-input";
    }
    return "https://demo.simplersell.com/_address-input";
};
var ADDRESS_INPUT_URL = getAddressInputUrl();
var ALLOWED_TYPES = [
    "street_address",
    "premise",
    "subpremise",
    "route"
];
var generateGoogleMapsSessionToken = function() {
    return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString();
};
var buildAutocompleteUrl = function(query, sessionToken) {
    return "".concat(ADDRESS_INPUT_URL, "/autocomplete?sessionToken=").concat(sessionToken, "&query=").concat(query);
};
var buildCityAutocompleteUrl = function(query, sessionToken) {
    return "".concat(ADDRESS_INPUT_URL, "/autocomplete?sessionToken=").concat(sessionToken, "&query=").concat(encodeURIComponent(query), "&types=(regions)");
};
var buildPlacesUrl = function(param) {
    var source = param.source, placeId = param.placeId, addressToken = param.addressToken, sessionToken = param.sessionToken;
    var baseUrl = "".concat(ADDRESS_INPUT_URL, "/place");
    if (source === "casa") {
        return baseUrl + "?addressToken=".concat(addressToken);
    }
    return baseUrl + "?sessionToken=".concat(sessionToken, "&placeId=").concat(placeId);
};


/***/ }),

/***/ 7419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YE": function() { return /* binding */ getRailsEnv; }
/* harmony export */ });
/* unused harmony exports isRailsEnv, assertRailEnvOrThrow */
var envs = (/* unused pure expression or super */ null && ([
    "production",
    "staging",
    "qa",
    "development",
    "localdev",
    "test"
]));
function isRailsEnv(env) {
    return envs.indexOf(env) !== -1;
}
function assertRailEnvOrThrow(env) {
    if (isRailsEnv(env)) {
        return env;
    }
    throw new Error("".concat(env, " is not a valid RailsEnv"));
}
var getRailsEnv = function() {
    var ref, ref1, ref2, ref3;
    if ( false || typeof document === "undefined") {
        return "development";
    }
    var hostname = window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.hostname;
    if (hostname === undefined) {
        return "development";
    }
    var port = window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.port;
    var locationHasPort = port && port !== "";
    var onLocalhost = hostname === "localhost";
    var onNgrok = hostname.includes(".ngrok.io");
    var onXipIO = hostname.includes(".xip.io");
    var inAndroidEmulator = hostname.includes("10.0.2.2");
    var inDevelopment = onLocalhost && locationHasPort || onNgrok || onXipIO || inAndroidEmulator;
    if (inDevelopment) {
        return "development";
    }
    // In Rails CI, tests my be on a random port
    var inRailsCI = hostname === "127.0.0.1";
    // on localhost without a port corresponds to test environment
    if (inRailsCI || onLocalhost) {
        return "test";
    }
    var onStagingManagedDomain = hostname.includes("-staging.managed.services.opendoor.com") || hostname.includes("-staging.ops.opendoor.com") || hostname.includes("-staging.opendoor.com");
    var onSimplersell = hostname.includes(".simplersell.com");
    var onODMortgage = hostname.includes(".odmortgage.com");
    var inStaging = onStagingManagedDomain || onSimplersell || onODMortgage;
    var inProduction = hostname.includes(".opendoor.com") && !hostname.includes("-staging");
    var inProdOrStaging = inStaging || inProduction;
    var onQADomain = hostname.includes("-qa-");
    var hasQACookie = (document === null || document === void 0 ? void 0 : (ref2 = document.cookie) === null || ref2 === void 0 ? void 0 : ref2.includes("qa=")) && (document === null || document === void 0 ? void 0 : (ref3 = document.cookie) === null || ref3 === void 0 ? void 0 : ref3.includes("qa_env="));
    // most QA usage will be on a staging domain (.e.g `demo.simplersell.com`) with appropriate
    // cookies set
    var inQA = onQADomain || inProdOrStaging && hasQACookie;
    if (inQA) {
        return "qa";
    } else if (inStaging) {
        return "staging";
    } else if (inProduction) {
        return "production";
    }
    // default case
    return "development";
};


/***/ })

}]);